<template>
  <div class="ibox-content mailbox-content">
    <h2>Lista de Caixas Abertos</h2>
    <form>
      <div class="input-group">
        {{ existentLabels }}
        <tags-input
          :tags="searchLabelsForDisplay"
          placeholder="Insira uma label"
          :select="true"
          :select-items="availableSearchLabels"
          @on-select="addSearchLabel"
          @on-tags-changed="syncSearchLabels"
        >
          <template #select-item="slotProps">
            {{ slotProps.value }}
          </template>
        </tags-input>

        <div class="input-group-btn">
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="searchAccountingCash"
            v-if="permissionRead"
          >
            <i class="fa fa-search"></i>
            Buscar
          </button>
        </div>
      </div>
    </form>
    <table class="table table-hover table-mail">
      <thead class="table-head">
        <tr>
          <th>Nome</th>
          <th>Labels</th>
          <th>Data de Abertura</th>
          <th></th>
        </tr>
      </thead>

      <tbody class="table-list">
        <tr v-for="(listItem, listIdx) in accountingList.list" :key="listIdx">
          <td>{{ listItem.name || listItem.user.fullName }}</td>
          <td>
            <div
              v-for="(label, index) in listItem.openingAccounting.labels"
              :key="index"
            >
              <LabelInfo :label="label" />
            </div>
          </td>
          <td>{{ DateBR(listItem.openingAccounting.openedDate) }}</td>

          <td class="list-command">
            <button
              class="btn btn-outline"
              @click="editMode(listItem)"
              v-if="permissionUpdate"
            >
              <i class="fa fa-edit text-success"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import LabelInfo from '../../../../components/labelInfo/LabelInfo';
export default {
  components: {
    LabelInfo,
  },
  props: {
    existentLabels: Array,
  },
  data() {
    return {
      searchForm: {
        form: {
          labels: [],
        },
        control: {},
      },
      accountingList: {
        originalList: [],
        list: [],
        control: {},
      },
    };
  },
  mounted() {
    this.loadAccounting();
  },
  computed: {
    searchLabelsForDisplay() {
      return this.searchForm.form.labels.map((l) => l.value);
    },
    availableSearchLabels() {
      const selectedKeys = this.searchForm.form.labels.map((l) => l.key);
      return this.existentLabels.filter((l) => !selectedKeys.includes(l.key));
    },
    permissionRead() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'READ',
      );
    },
    permissionUpdate() {
      return this.$store.getters['DATA-ACCESS/HasAccess'](
        'manager-accounting-cash',
        'UPDATE',
      );
    },
  },
  methods: {
    addSearchLabel(item) {
      if (!this.searchForm.form.labels.find((l) => l.key === item.key)) {
        this.searchForm.form.labels.push(item);
      }
    },
    syncSearchLabels(tags) {
      this.searchForm.form.labels = this.existentLabels.filter((l) =>
        tags.includes(l.value),
      );
    },
    DateBR(dt) {
      return new Date(dt).toLocaleString('pt-br');
    },
    editMode(item) {
      this.$emit('edit-mode', item);
    },
    async loadAccounting() {
      const accountingList = await this.$store.dispatch(
        'ACCOUNTING-CASH/ListAllOpened',
        false,
      );
      this.accountingList.originalList = accountingList;
      this.searchAccountingCash();
    },
    searchAccountingCash() {
      if (!this.permissionRead) {
        return;
      }
      if (!this.searchForm.form.labels[0]) {
        this.accountingList.list = this.accountingList.originalList;
        return;
      }

      const filteredLabels = this.searchForm.form.labels.map(
        label => label.key,
      );

      const listFiltered = this.accountingList.originalList.filter(
        item =>
          item.openingAccounting.labels.findIndex(label =>
            filteredLabels.includes(String(label)),
          ) >= 0,
      );

      this.accountingList.list = listFiltered;
    },
  },
};
</script>